import { render, staticRenderFns } from "./CommentManagement.vue?vue&type=template&id=36040779&scoped=true"
import script from "./CommentManagement.vue?vue&type=script&lang=js"
export * from "./CommentManagement.vue?vue&type=script&lang=js"
import style0 from "./CommentManagement.vue?vue&type=style&index=0&id=36040779&prod&lang=scss&scoped=true"
import style1 from "./CommentManagement.vue?vue&type=style&index=1&id=36040779&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36040779",
  null
  
)

export default component.exports